import { api } from "../lib/apiClient";

/** POST /ciaoV2_pros_interactions */
export async function createProsInteraction(payload, authToken) {
  const payloadMapped = {
    ciaov2_job_id: payload.ciaov2_job_id,
    ciaov2_user_id: payload.ciaov2_user_id,
    gender: payload.gender,
    name: payload.name
  }
  const { data } = await api.post("/ciaoV2_pros_interactions", payloadMapped, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
}

/** GET /ciaoV2_pros_interactions      →  l'historique d'un user */
export async function fetchProsInteraction(authToken) {
  const { data } = await api.get("/ciaoV2_pros_interactions", {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
}

/** POST /ciaov2_job_synthesis      →  génère la synthèse pour un job */
export async function generateJobSynthesis(jobId, authToken) {
  const { data } = await api.post("/ciaov2_job_synthesis",
    { job_id: jobId },
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
}
